import moment from 'moment';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import useStore from '../../../store/zustand/store';
import Button from '../../molecules/Button';
import GoActivityButton from './components/GoActivityButton';
import LoginButton from './components/LoginButton';
import SubscribeButton from './components/SubscribeButton';
import UnsubscribeButton from './components/UnsusbcribeButton';
import config from '../../../config';

const DISABLED_STATUS = [
  3, // Cerrada
  4, // Archivada
];

const now = moment().subtract(1, 'days');

const ActivityButton = ({ activity, btnCard = false }) => {
  const user = useStore((state) => state.user);
  const [isSuscribed, setIsSuscribed] = useState(!!activity.activity_user_id);
  const { t } = useTranslation();
  const location = useLocation();

  const isOnActivityDetailPage = location.pathname === `/detail/${activity.id}`;

  const isEnable = useMemo(() => {
    // Si la actividad tiene este estado, no se puede inscribir
    if (DISABLED_STATUS.includes(activity.status)) return false;

    // Si todavia no paso la fecha de cierre o es una actividad continua, se puede inscribir
    if (now <= moment(activity.deadline) || activity.continuous_activity) return true;

    // no se puede inscribir
    return false;
  }, [activity]);

  // Si no hay usuario, mostrar boton de Login
  if (!user) return <LoginButton btnCard={!config.profile_globant && btnCard} />;

  // Si el administrador oculta los botones de postulacion/despostulacion
  if (activity.hidden_button) {
    // Solo mostrar el botón de ir a la actividad si el usuario esta suscrito
    if (isSuscribed) {
      return <GoActivityButton activity={activity} btnCard={!config.profile_globant && btnCard} />;
    }
    return null; // No mostrar otros botones
  }

  //if (!user) return <LoginButton />;
  if (!isEnable) {
    return (
      <Button
        className={'button-reactour'}
        style={btnCard ? { borderRadius: '10px', width: '100%', padding: '5px 0px', fontWeight: 500 } : {}}
      >
        {t(!!activity.guide_id ? 'button.enroll_me' : 'button.apply')}
      </Button>
    );
  }

  if (!isSuscribed) {
    return (
      <SubscribeButton
        activity={activity}
        setIsSuscribed={setIsSuscribed}
        btnCard={!config.profile_globant && btnCard}
      />
    );
  }

  if (isOnActivityDetailPage) {
    return <UnsubscribeButton activity={activity} setIsSuscribed={setIsSuscribed} />;
  } else if (!isOnActivityDetailPage) {
    return <GoActivityButton activity={activity} btnCard={!config.profile_globant && btnCard} />;
  }

  return (
    <Button
      className="button-reactour"
      style={btnCard ? { borderRadius: '10px', width: '100%', padding: '5px 0px', fontWeight: 500 } : {}}
    >
      {t(!!activity.guide_id ? 'button.enroll_me' : 'button.apply')}
    </Button>
  );
};

export default ActivityButton;

/* Solucion a Ticket que se me ocurrio

Peticion: Necesitamos ajustar el comportamiento del componente ActivityButton de manera que el boton de 
ir a la actividad se muestre en la card de la actividad incluso cuando el administrador elige ocultar 
el botón de postularme/despostularme

Solucion: En vez de ocultar todos los botones cuando hidden_button es true: 
* Si el boton es Postularme o despostularme y esta oculto, entonces null solo debería aplicarse para esos 
botones. De todos modos, ir a la actividad debería seguir mostrandose. Por lo tanto si hidden_button esta
activado, el botón de ir a la Actividad todavía se mostrara para el usuario, mientras que postularme
o despostularme estaran ocultos.

// Si no hay usuario, mostrar boton de Login
  if (!user) return <LoginButton />;

  // Si el administrador oculta los botones de postulacion/despostulacion
  if (activity.hidden_button) {
    // Solo mostrar el botón de ir a la actividad si el usuario esta suscrito
    if (isSuscribed) {
      return <GoActivityButton activity={activity} />;
    }
    return null; // No mostrar otros botones
  }
*/
